import { gql } from '@apollo/client';

import { EsSyncTaskResult } from './syncEsByTimeRange';

export interface SyncHistoryEsByTimeRangeResponse {
    syncHistoryEsByTimeRange: EsSyncTaskResult;
}

export interface SyncHistoryEsByTimeRangeVariables {
    input: {
        startTime: string; // ISO-8601
        endTime: string;
    };
}

/**
 * 按订单创建时间段把 order_history 回填到历史 ES 索引（order_listing_history）。
 *
 * 与 SYNC_ES_BY_TIME_RANGE 入参、返回结构完全一致，只是目标索引不同：
 * 那个同步在途订单索引，本接口同步归档订单索引。
 *
 * 触发即返回，实际同步在 order-service 异步执行；重复点同一时间段无副作用
 * （ES 侧按 order.id 覆盖写，天然幂等）。
 */
export const SYNC_HISTORY_ES_BY_TIME_RANGE = gql`
    mutation SyncHistoryEsByTimeRange($input: SyncEsByTimeRangeInput!) {
        syncHistoryEsByTimeRange(input: $input) {
            taskId
            estimatedOrderCount
            description
        }
    }
`;
